module.exports = __webpack_public_path__ + "img/stop-7.55d699ca.jpg";